import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import ExamLayout from '../views/ToeicSpeaking/ExamLayout.vue'
import ToeicExam from '../views/ToeicSpeaking/Exam.vue'
import ToeicExamBridge from '../views/ToeicSpeaking/Exam_bridge.vue'
import VocabulariesLayout from '../views/Toeic/Layout.vue'
import Vocabularies from '../views/Toeic/Vocabularies.vue'
import VocabulariesList from '../views/Toeic/VocabulariesList.vue'
import Raiders from '../views/Toeic/Raiders.vue'
import Channels from '../views/Channels.vue'
import Course from '../views/Course.vue'
import CourseLesson from '../views/CourseLesson.vue'
import Login from '../views/Login.vue'
import Personal from '../views/Personal.vue'
import Record from '../components/Record.vue'
import LeaderBoard from '../components/LeaderBoard.vue'
import Collections from '../components/Collections.vue'
import Teacher from '../views/Teacher.vue'
import Summary from '../components/teacher/Summary.vue'
import ExamSummary from '../components/teacher/exam/Exam-summary.vue'
import AIRecord from '../components/teacher/AIRecord.vue'
import Search from '../views/Search.vue'
import LessonSummary from '../components/teacher/LessonSummary.vue'
import Info from '../components/teacher/Info.vue'
import StudentInfo from '../components/teacher/StudentInfo.vue'
import VoiceRecord from '../components/VoiceRecord.vue'
import Curve from '../components/teacher/Curve.vue'
import ExamHall from '../components/Exam-hall.vue'
import DetailExam from '../components/Exam-detail.vue'
import OralExam from '../components/Oral-Exam.vue'
import Room from '../components/teacher/room/Room.vue'
import Campus from '../views/Campus.vue'
import GroupManagement from '../components/campus/GroupManagement.vue'
import ModifyRoom from '../components/teacher/room/ModifyRoom.vue'
import ThDetailExam from '../components/teacher/room/Exam-detail.vue'
import AiSummary from '../components/campus/ai_controller/Summary.vue'
import AiGroupSummary from '../components/campus/ai_controller/GroupSummary.vue'
import AiPersonalSummary from '../components/campus/ai_controller/PersonalSummary.vue'
import AiModify from '../components/campus/ai_controller/Modify.vue'
import AiHelperLayout from '../views/AiHelper/Layout.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { hideHeader: true }
  },
  {
    path: '/channels/:channel',
    name: 'Channels',
    component: Channels,
    meta: { requiresAuth: true, hideHeader: false }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    props: route => ({ query: route.query.q }),
    meta: { requiresAuth: true, hideHeader: false }
  },
  {
    path: '/course/:channel',
    name: 'Course',
    component: Course,
    meta: { requiresAuth: true, hideHeader: false }
  },
  {
    path: '/course-lesson/:lesson/:groupId/:studentId/:courseId',
    name: 'CourseLesson',
    component: CourseLesson,
    meta: { requiresAuth: true, hideHeader: false }
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: { requiresAuth: true, hideHeader: false },
    children: [
      { path: 'collections', name: 'Collections', component: Collections },
      { path: 'record', name: 'Record', component: Record },
      { path: 'record/:groupId/:lessonId?/:studentId?', name: 'PersonalVoiceRecord', component: VoiceRecord },
      { path: 'leaderBoard', name: 'LeaderBoard', component: LeaderBoard },
      { path: 'exam-hall', name: 'Exam-hall', component: ExamHall },
      { path: 'exam-hall/:examId/:repeatable', name: 'Oral-exam', component: OralExam },
      { path: 'exam-detail/:examId', name: 'Exam-detail', component: DetailExam }
    ]
  },
  {
    path: '/teacher',
    name: 'Teacher',
    component: Teacher,
    meta: { requiresAuth: true, hideHeader: false },
    children: [
      { path: 'summary/:groupId/', name: 'Summary', component: Summary },
      { path: 'summary/:groupId/:lessonId?', name: 'LessonSummary', component: LessonSummary },
      { path: 'summary/:groupId/:lessonId?/:studentId?', name: 'VoiceRecord', component: VoiceRecord },
      { path: 'info/:groupId/', name: 'Info', component: Info },
      { path: 'info/:groupId/:studentId?', name: 'StudentInfo', component: StudentInfo },
      { path: 'info/:groupId/:studentId?/:lessonId?', name: 'VoiceRecordInfo', component: VoiceRecord },
      { path: 'curve/:groupId/:studentId?', name: 'Curve', component: Curve },
      { path: 'room/:groupId/', name: 'Room', component: Room },
      { path: 'room/:groupId/:roomId', name: 'ModifyRoom', component: ModifyRoom },
      { path: 'detail/:groupId/:examId?', name: 'Score', component: ThDetailExam },
      { path: 'toeic/:groupId/', name: 'Exam-Toeic-Summary', component: ExamSummary },
      { path: 'bridge/:groupId/', name: 'Exam-Bridge-Summary', component: ExamSummary },
      { path: 'gept/:groupId/', name: 'Exam-Summary', component: ExamSummary },
      { path: 'toeic-personal/:groupId', name: 'Exam-Toeic-Personal', component: ExamSummary },
      { path: 'bridge-personal/:groupId', name: 'Exam-Bridge-Personal', component: ExamSummary },
      { path: 'gept-personal/:groupId', name: 'Exam-Personal', component: ExamSummary },
      { path: 'AI-Record/:groupId/', name: 'AI-Record', component: AIRecord },
      { path: 'AI-Record/:groupId/:studentId?', name: 'AI-Record-Personal', component: AIRecord }
    ]
  },
  {
    path: '/campus',
    name: 'Campus',
    component: Campus,
    meta: { requiresAuth: true, hideHeader: false },
    children: [
      { path: 'ai_summary/:groupId', name: 'AiSummary', component: AiSummary },
      { path: 'ai_controller/:groupId', name: 'AiGroupSummary', component: AiGroupSummary },
      { path: 'ai_modify/:groupId', name: 'AiModify', component: AiModify },
      { path: 'ai_personal/:groupId/', name: 'AiPersonalSummary', component: AiPersonalSummary },
      { path: 'group_management/:groupId/', name: 'GroupManagement', component: GroupManagement }
    ]
  },
  { path: '/AI', name: 'AI_Home', component: () => import('@/views/AiHelper/Home.vue'), meta: { requiresAuth: true, hideHeader: false } },
  { path: '/AI/records', name: 'ai_records', component: () => import('@/views/AiHelper/Records.vue'), hideHeader: false },
  {
    path: '/AI_assistant',
    name: 'AI_assistant',
    component: AiHelperLayout,
    meta: { requiresAuth: true, hideHeader: false },
    children: [
      { path: 'intro', name: 'ai_assistantIntro', component: () => import('@/views/AiHelper/Intro.vue') },
      { path: 'generate/:aiType', name: 'ai_assistantMain', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'generate/correction/:aiType', name: 'ai_assistant_correction', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'generate/follow/:aiType', name: 'ai_assistant_follow', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'generate/view/:aiType/:promptId?/:generateType?', name: 'viewGenerate', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'chat/en/:promptId?', name: 'chatAI', component: () => import('@/views/AiHelper/ChatContent.vue') },
      { path: 'chat/jp/:promptId?', name: 'ChatAIJp', component: () => import('@/views/AiHelper/ChatContent.vue') },
      { path: 'chat_history', name: 'chat_history', component: () => import('@/views/AiHelper/ChatHistory.vue') },
      { path: 'view/:lang', name: 'viewChat', component: () => import('@/views/AiHelper/ChatContent.vue') },
      { path: 'conversation_rating', name: 'conversation_rating', component: () => import('@/views/AiHelper/ChatRate.vue') },
      { path: 'records', name: 'records', component: () => import('@/views/AiHelper/Records.vue') }
    ]
  },
  {
    path: '/speaking/:channel',
    component: ExamLayout,
    children: [
      { path: 'normal/:id?', name: 'Topic-Exam', component: ToeicExam },
      { path: 'bridge/:id?', name: 'Topic-Exam-Bridge', component: ToeicExamBridge }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/toeic/raiders',
    name: 'Raiders',
    component: Raiders,
    meta: { requiresAuth: true }
  },
  {
    path: '/toeic/vocabularies',
    component: VocabulariesLayout,
    children: [
      { path: '', name: 'Toeic-Vocabularies', component: Vocabularies },
      { path: ':id/:subId', name: 'Toeic-List', component: VocabulariesList }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/TOEIC',
    name: 'TOEIC',
    component: () => import('@/views/AiHelper/TOEIC/Layout.vue'),
    meta: { requiresAuth: true, hideHeader: true },
    children: [
      { path: 'list/:exam_type', name: 'TOEIC_list', component: () => import('@/views/AiHelper/TOEIC/List.vue') },
      { path: 'exam/:practice_type/:exam_id', name: 'TOEIC_exam', component: () => import('@/views/AiHelper/TOEIC/Practice.vue') },
      { path: 'exam/bridge/:practice_type/:exam_id', name: 'TOEIC_bridge', component: () => import('@/views/AiHelper/TOEIC/Practice.vue') },
      { path: 'report/:practice_type/:record_id', name: 'TOEIC_report', component: () => import('@/views/AiHelper/TOEIC/Report.vue') },
      { path: 'detailed_explanation/:practice_type/:record_id', name: 'detailed_explanation', component: () => import('@/views/AiHelper/TOEIC/detailed_explanation.vue') }
    ]
  },
  {
    path: '/GEPT',
    name: '',
    component: () => import('@/views/AiHelper/GEPT/Layout.vue'),
    meta: { requiresAuth: true, hideHeader: true },
    children: [
      { path: 'overview', name: 'GEPT_Overview', component: () => import('@/views/AiHelper/GEPT/Overview.vue'), meta: { requiresAuth: true, gtm: 'GEPT_Overview' } },

      { path: 'p/:select_id/:practice_type?', name: 'practice_speaking', component: () => import('@/views/AiHelper/GEPT/Practice.vue'), meta: { requiresAuth: true, gtm: 'practice_speaking' } },
      { path: 'f/:select_id/:practice_type?', name: 'formal_exam', component: () => import('@/views/AiHelper/GEPT/Practice.vue'), meta: { requiresAuth: true, gtm: 'formal_exam' } },

      { path: 'report/:select_id/:record_id', name: 'gept_report_part', component: () => import('@/views/AiHelper/GEPT/Report.vue'), meta: { requiresAuth: true, gtm: 'gept_report_part' } },
      { path: 'report_formal_exam/:record_id', name: 'gept_report_formal', component: () => import('@/views/AiHelper/GEPT/Report.vue'), meta: { requiresAuth: true, gtm: 'gept_report/formal' } }
    ]
  },
  {
    path: '/quiz',
    name: '',
    component: () => import('@/views/AiHelper/GEPT/Layout.vue'),
    meta: { requiresAuth: true, hideHeader: true },
    children: [
      { path: 'overview', name: 'quiz_Overview', component: () => import('@/views/AiHelper/GEPT/Overview.vue'), meta: { requiresAuth: true, gtm: 'quiz_Overview' } },

      { path: 'p/:select_id/:practice_type?', name: 'quiz_practice_speaking', component: () => import('@/views/AiHelper/GEPT/Practice.vue'), meta: { requiresAuth: true, gtm: 'practice_speaking' } },
      // { path: 'f/:select_id/:practice_type?', name: 'formal_exam', component: () => import('@/views/AiHelper/GEPT/Practice.vue'), meta: { requiresAuth: true, gtm: 'formal_exam' } },

      // { path: 'report/:select_id/:record_id', name: 'quiz_report_part', component: () => import('@/views/AiHelper/GEPT/Report.vue'), meta: { requiresAuth: true, gtm: 'gept_report_part' } },
      { path: 'report_quiz/:record_id', name: 'quiz_report_formal', component: () => import('@/views/AiHelper/GEPT/Report.vue'), meta: { requiresAuth: true, gtm: 'gept_report/formal' } }
    ]
  },
  { path: '*', redirect: { name: 'Login' } }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
